import Documents from './Documents'

export default Documents



// WEBPACK FOOTER //
// ./src/components/Documents/index.js